import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RestoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"restore"}/>
}
